// @ts-strict-ignore
import React from 'react'
import { useQueryClient } from '@tanstack/react-query'
import { actionAtom } from 'atoms/atoms'
import { useAtomValue } from 'jotai'
import { useTranslation } from 'react-i18next'
import { useParams } from 'react-router'
import { Box, Button, Illustration } from '@node-space/ui-components'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'

export const MassPayoutsUploadApprovals = () => {
  const { t } = useTranslation()
  const queryClient = useQueryClient()
  const action = useAtomValue(actionAtom)
  const { reference: batchId } = useParams()

  const handleClose = () => {
    queryClient.invalidateQueries({ queryKey: reactQueryKeys.massCryptoPayoutById(batchId) })
    action?.onClose()
  }

  return (
    <Box data-testid="upload-approvals">
      <Box flexCol align="center" paddingB={24} paddingX={32} gap={12}>
        <Illustration name="HourGlassLow" color="info" />
        <h1 className="text-foreground-prominent text-h1">{t('approvals.sentForApproval')}</h1>
        <span className="text-foreground-prominent text-body-regular">
          {t('approvals.mayRequireApprovalMassPayDisclaimer')}
        </span>
        <span className="text-foreground-prominent text-body-regular">
          {t('approvals.mayRequireApprovalMassPayHelper')}
        </span>
        <Button testId="done" onClick={handleClose}>
          {t('done')}
        </Button>
      </Box>
    </Box>
  )
}
